import { createFileRoute, redirect } from '@tanstack/react-router';

/*
 * The console has no home page of its own. Every audience but staff was moved
 * to the customer app, so there is exactly one place to start and no landing
 * screen worth the click it would cost.
 */
export const Route = createFileRoute('/_app/')({
  staticData: { orgScope: 'none' },
  beforeLoad: () => {
    throw redirect({ to: '/tracks' });
  },
});
